<app-header [currentModule]="moduloEnum" [currentModuleFuncionality]="funcionalidadeEnum"></app-header>

<div class="container-header">
  <div class="container-header-inner">
    <div class="row">
      <div class="col-12">
        <div class="d-flex align-items-center flex-wrap gap-3">
          <h1 class="title-default">Ambiente da Nota Fiscal</h1>
          @if (podeVisualizar && !podeAlterar) {
            <span
              class="status-badge badge-cinza"
              matTooltip="Seu perfil pode consultar e testar o ambiente, mas não alterar.">
              <mat-icon class="material-symbols-outlined">lock</mat-icon>
              Somente leitura
            </span>
          }
        </div>
        <p class="welcome-message">
          <button
            mat-icon-button
            type="button"
            (click)="voltar()"
            [matTooltip]="tooltipVoltar"
            [attr.aria-label]="tooltipVoltar">
            <mat-icon>arrow_back</mat-icon>
          </button>
          Defina se as notas fiscais são emitidas em homologação ou em produção e teste a comunicação com a
          Sefaz.
        </p>
      </div>
    </div>

    @if (!podeVisualizar) {
      <app-alert-card type="warning">
        Você não tem permissão para visualizar as configurações de notas fiscais.
      </app-alert-card>
    } @else if (isLoading) {
      <div class="section-container">
        <app-loading-box height="30" width="220" marginTop="0"></app-loading-box>
        <app-loading-box height="64" width="100%" marginTop="16"></app-loading-box>
        <div class="action-card-grid mt-3">
          <app-loading-box height="120" width="100%" marginTop="0"></app-loading-box>
          <app-loading-box height="120" width="100%" marginTop="0"></app-loading-box>
        </div>
      </div>
    } @else {
      <div class="section-container" id="ambiente-emissao">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">dns</mat-icon>
          <span>Tipo ambiente padrão</span>
          <div class="section-title-actions ms-auto">
            <button
              mat-button
              type="button"
              class="btn-section"
              (click)="testarAmbiente()"
              [disabled]="isTestando || idTipoAmbienteSelecionado == null"
              aria-label="Consultar status do ambiente"
              [attr.aria-busy]="isTestando"
              matTooltip="Consulte o status da Sefaz no ambiente selecionado na tela, mesmo antes de salvar.">
              @if (!isTestando) {
                <mat-icon class="material-symbols-outlined">autorenew</mat-icon>
              }
              @if (isTestando) {
                <mat-spinner diameter="20"></mat-spinner>
              } @else {
                Consultar status do ambiente
              }
            </button>
          </div>
        </div>

        <app-alert-card type="info">
          A Sefaz mantém dois tipos de ambientes: Homologação, para testes, e Produção, para o dia a dia da empresa. O
          ambiente escolhido aqui vale para os emissores que estão com o tipo ambiente marcado como Automático.
        </app-alert-card>

        <div
          class="action-card-grid mt-3"
          role="radiogroup"
          aria-label="Tipo ambiente padrão">
          @for (opcao of opcoesAmbiente; track opcao.idTipoAmbiente) {
            <button
              type="button"
              class="action-card-action"
              role="radio"
              [attr.aria-checked]="idTipoAmbienteSelecionado === opcao.idTipoAmbiente"
              [disabled]="bloquearSelecao"
              (click)="selecionar(opcao.idTipoAmbiente)">
              <app-action-card
                [title]="opcao.titulo"
                [icon]="opcao.icone"
                [description]="opcao.consequencia"
                [interactive]="true"
                [disabled]="bloquearSelecao"
                [selected]="idTipoAmbienteSelecionado === opcao.idTipoAmbiente">
                <mat-icon cardActions class="material-symbols-outlined" aria-hidden="true">
                  {{
                    idTipoAmbienteSelecionado === opcao.idTipoAmbiente
                      ? 'radio_button_checked'
                      : 'radio_button_unchecked'
                  }}
                </mat-icon>
              </app-action-card>
            </button>
          }
        </div>

      </div>

      <div class="section-container" id="modelos-emitidos">
        <div class="section-title">
          <mat-icon class="material-symbols-outlined">receipt_long</mat-icon>
          <span>Modelos documentos liberados para emissão</span>
        </div>
        <p class="section-sub-title">
          Libera os modelos que os emissores da empresa podem emitir. Para desligar um modelo, desative-o
          antes nos emissores que o usam.
        </p>

        <div class="toggle-content">
          <mat-slide-toggle
            class="app-toggle-compact"
            [(ngModel)]="emiteNFeSelecionado"
            [disabled]="bloquearSelecao"
            >Emite NF-e</mat-slide-toggle
          >
          <span class="info-text"
            >NF-e - Nota Fiscal Eletrônica (modelo 55), utilizada nas operações com produtos.</span
          >
        </div>
        <div class="toggle-content">
          <mat-slide-toggle
            class="app-toggle-compact"
            [(ngModel)]="emiteNFCeSelecionado"
            [disabled]="bloquearSelecao"
            >Emite NFC-e</mat-slide-toggle
          >
          <span class="info-text"
            >NFC-e - Nota Fiscal de Consumidor Eletrônica (modelo 65), utilizada nas vendas ao consumidor
            final.</span
          >
        </div>
      </div>
    }
  </div>
</div>

@if (podeAlterar) {
  <app-footer-action
    [isLoadingSalvar]="isSaving"
    [isSalvarDisabled]="!houveAlteracao || !configCarregada || isLoading"
    (salvar)="salvar()"
    (cancelar)="cancelar()">
  </app-footer-action>
}
